export default {
  Good: 'good',
  Average: 'average',
  Poor: 'poor',
  Unusable: 'unusable',
}
